'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var blue = {};

exports.__exports = blue;
